import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "react-router-dom";
import { CdpProvider } from "./lib/coinbase/CdpProvider";
import { queryClient } from "./lib/queryClient";
import { router } from "./router";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { IdentityCacheGuard } from "./components/IdentityCacheGuard";

export function App() {
  return (
    <ErrorBoundary>
      <CdpProvider>
        <QueryClientProvider client={queryClient}>
          <IdentityCacheGuard />
          <RouterProvider router={router} />
        </QueryClientProvider>
      </CdpProvider>
    </ErrorBoundary>
  );
}
